/*
  Lilymoon: 商品カードのお気に入り（ハート）に「お気に入りに入れた人の数」を出す。
  数は Swym（Wishlist Plus）から 10件ずつまとめて取る。画面に近づいたカードの分だけ取る。
  取れなかったとき・Swym が読み込まれなかったときは何も出さない（ハートは今までどおり動く）。
  枠は snippets/product-block.liquid の .lm-wish-count。
*/
(function () {
  var MIN = 1; // この数より少ない商品には出さない
  var TTL = 10 * 60 * 1000; // 同じ商品の数を取り直すまでの時間
  var KEY = 'lmWishCount';
  var BTN = '.wishlist-btn[data-product-id]';

  var swat = null, cache = {}, queue = [], asked = {}, latest = {}, timer = null, scanTimer = null;

  try { cache = JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) {}

  function save() {
    try {
      if (Object.keys(cache).length > 600) cache = {};
      sessionStorage.setItem(KEY, JSON.stringify(cache));
    } catch (e) {}
  }

  function label(n) {
    if (n < 1000) return String(n);
    if (n < 10000) return (Math.floor(n / 100) / 10).toFixed(1).replace(/\.0$/, '') + 'K';
    return Math.floor(n / 1000) + 'K';
  }

  function paint(id, n) {
    document.querySelectorAll('.wishlist-btn[data-product-id="' + id + '"] .lm-wish-count').forEach(function (el) {
      if (n >= MIN) { el.textContent = label(n); el.dataset.len = el.textContent.length; el.hidden = false; } else { el.hidden = true; }
    });
  }

  function store(row) {
    if (!row || row.empi == null) return;
    var n = Math.max(0, +row.count || 0);
    cache[row.empi] = [n, Date.now()];
    paint(row.empi, n);
  }

  function flush() {
    timer = null;
    if (!swat || !queue.length) return;
    var ids = queue.splice(0, 10);
    swat.wishlist.getSocialCountBatch(ids, function (res) {
      ((res && res.data) || []).forEach(store);
      save();
    }, function () {
      ids.forEach(function (id) { delete asked[id]; });
    });
    if (queue.length) timer = setTimeout(flush, 60);
  }

  function ask(id) {
    if (asked[id]) return;
    asked[id] = true;
    queue.push(id);
    if (!timer) timer = setTimeout(flush, 80);
  }

  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      ask(+entry.target.dataset.productId);
    });
  }, { rootMargin: '400px' }) : null;

  function scan() {
    scanTimer = null;
    document.querySelectorAll(BTN + ':not([data-lm-count])').forEach(function (btn) {
      var id = +btn.dataset.productId;
      if (!id) return;
      btn.setAttribute('data-lm-count', '');
      if (btn.hasAttribute('aria-pressed')) show(btn, isOn(btn));
      var hit = cache[id];
      if (hit && Date.now() - hit[1] < TTL) { paint(id, hit[0]); return; }
      if (io) io.observe(btn); else ask(id);
    });
  }

  // ハートを押したら、その場でハートの塗りと数を動かす（2026/10/12）。
  // 「お気に入りに入っているか」は Swym が付ける aria-pressed で見る。Swym のクラス（swym-added）は解除しても外れず、
  // 解除→もう一度追加で食い違うので使わない。塗りは data-lm-on（1/0）で出す（CSS は snippets/product-block.liquid）。
  function isOn(btn) { return btn.getAttribute('aria-pressed') === 'true'; }

  function show(btn, on) { btn.setAttribute('data-lm-on', on ? '1' : '0'); }

  function bump(id, delta) {
    var hit = cache[id];
    if (!hit) return;
    var n = Math.max(0, hit[0] + delta);
    cache[id] = [n, Date.now()];
    paint(id, n);
    save();
  }

  // Swym の処理が終わった（または 6秒たった）とき。結果が押した向きと違えば、先に動かした分を戻す
  function settle(btn) {
    var job = btn.lmJob;
    if (!job) return;
    clearTimeout(job.timer);
    btn.lmJob = null;
    var on = isOn(btn);
    show(btn, on);
    if (on !== job.want) { job.undone = true; bump(job.id, job.want ? -1 : 1); }
  }

  // Swym は追加に成功しても、このボタンを「追加中」のまま固めて解除の動きに切り替えないことがある
  //（2026/10/12 実測: サーバーには入っているのに aria-pressed が false のまま・押しても何も起きない。再読み込みすると直る）。
  // 追加がリストに入ったのを確かめてから、このボタンだけ Swym に初期化し直させる（再読み込みのときと同じ処理）。
  function reinit(btn) {
    var box = btn.parentElement;
    if (!box || !swat.initializeActionButtons) return;
    box.setAttribute('data-lm-swym-init', '');
    try { swat.initializeActionButtons('[data-lm-swym-init]'); } catch (e) {}
    box.removeAttribute('data-lm-swym-init');
  }

  function unstick(btn, job, tries) {
    setTimeout(function () {
      if (btn.lmJob !== job || isOn(btn)) return; // Swym が自分で切り替えた
      var again = function () { if (tries < 2) unstick(btn, job, tries + 1); };
      swat.api.fetch(function (list) {
        if (btn.lmJob !== job || isOn(btn)) return;
        if ((list || []).some(function (row) { return row.empi == job.id; })) reinit(btn); else again();
      }, again);
    }, [600, 1200, 2000][tries]);
  }

  // 入っているハートを押したとき（AllowToggle がオフの店だけ）。一覧からその商品の行を取り、全部外してから、
  // このボタンを Swym に初期化し直させる（「入っていない」状態＝押すと追加、に戻る）。
  // Swym 自身の押下処理は止めない（商品リンクへ飛ばないようにしているのが Swym 側のため）
  function unfave(btn, id) {
    var job = { id: id, want: false, base: cache[id] ? cache[id][0] : null, undone: false };
    job.timer = setTimeout(function () { settle(btn); }, 6000);
    btn.lmJob = job;
    latest[id] = job;
    show(btn, false);
    bump(id, -1);
    swat.api.fetch(function (list) {
      var rows = (list || []).filter(function (row) { return row.empi == id; });
      var done = function () {
        btn.classList.remove('disabled', 'swym-added', 'swym-adding', 'swym-removing');
        reinit(btn);
      };
      var next = function () {
        var row = rows.shift();
        if (!row) { done(); return; }
        swat.api.removeFromWishList(row, next);
      };
      next();
    }, function () {});
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest(BTN);
    // 追加・解除の途中は Swym が次の押下を受け付けないので、こちらも動かさない
    if (!btn || !swat || btn.lmJob || !btn.classList.contains('swym-loaded')) return;
    var id = +btn.dataset.productId;
    // Swym の設定（Wishlist.AllowToggle）がオフの店では、入っているハートをもう一度押しても Swym は解除しない。
    // こちらで Swym の「リストから外す」を呼ぶ（2026/10/12 あお「ハートで解除できるようにしたい」）
    if (isOn(btn) && !(((swat.retailerSettings || {}).Wishlist || {}).AllowToggle)) { unfave(btn, id); return; }
    var job = { id: id, want: !isOn(btn), base: cache[id] ? cache[id][0] : null, undone: false };
    job.timer = setTimeout(function () { settle(btn); }, 6000);
    btn.lmJob = job;
    latest[id] = job;
    show(btn, job.want);
    bump(id, job.want ? 1 : -1);
    if (job.want) unstick(btn, job, 0);
    // そのあと Swym の数も見にいく。押す前の数のまま返ってくる間（Swym 側の反映待ち）は、先に出した数を残す
    [4000, 8000].forEach(function (wait) {
      setTimeout(function () {
        swat.wishlist.getSocialCountImmediate({ empi: id }, function (res) {
          var row = res && res.data;
          // 同じ商品をそのあとまた押していたら、古い押下の分は捨てる（新しい押下で出した数を上書きしない）
          if (!row || latest[id] !== job) return;
          if (!job.undone && job.base != null && Math.max(0, +row.count || 0) === job.base) return;
          store(row);
          save();
        }, function () {});
      }, wait);
    });
  }, true);

  // Swym が aria-pressed を書いたら（読み込み時・追加や解除が終わったとき）、塗りを合わせる
  function watchPressed() {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        var btn = record.target;
        if (!btn.matches || !btn.matches(BTN)) return;
        if (!btn.lmJob) show(btn, isOn(btn));
        else if (isOn(btn) === btn.lmJob.want) settle(btn);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['aria-pressed'], subtree: true });
  }

  function start(s) {
    if (swat || !s || !s.wishlist || !s.wishlist.getSocialCountBatch) return;
    swat = s;
    scan();
    watchPressed();
    // 絞り込み・ページ送り・おすすめ商品など、あとから差し込まれるカードにも付ける
    new MutationObserver(function () {
      if (!scanTimer) scanTimer = setTimeout(scan, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(start);
})();
